import type React from 'react';
import './styles.scss';

type TableProps = {
	header?: React.ReactNode;
	body?: React.ReactNode;
	footer?: React.ReactNode;
};

export const Table = ({ header, body, footer }: TableProps) => {
	return (
		<>
			<div className="table__wrap">
				<table className="table">
					<thead>{header}</thead>
					<tbody>{body}</tbody>
				</table>
			</div>
			<div className="table__foot">{footer}</div>
		</>
	);
};
